const WORDS = [
  "Chaises ergonomiques",
  "Lampes de bureau",
  "Outils numériques",
  "Top ventes en direct",
  "Sélection indépendante",
  "Liens partenaires signalés",
];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section data-testid="editorial-marquee" className="overflow-hidden border-y border-[var(--line)] bg-[var(--bone-2)] py-6">
      <div className="flex w-max animate-marquee">
        {row.map((w, i) => (
          <span key={i} className="flex items-center gap-10 pr-10">
            <span className="font-display text-2xl sm:text-4xl italic font-light whitespace-nowrap">{w}</span>
            <svg viewBox="0 0 20 20" className="h-4 w-4 shrink-0 text-[var(--terra)]" aria-hidden="true">
              <path d="M10 0 L12 8 L20 10 L12 12 L10 20 L8 12 L0 10 L8 8 Z" fill="currentColor" />
            </svg>
          </span>
        ))}
      </div>
    </section>
  );
};
